
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-services",
      function () {
        return require("private-next-pages/terms-services/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-services"])
      });
    }
  